import Vue from 'vue'
import QueryString from "querystring";
import {API_HOST} from "../settings/server";
import $store from "../store";
import axios from "axios";

class AuthService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    auth({username, password}) {
        return Vue.axios.post(`${API_HOST}/token`, QueryString.stringify({
            grant_type: "password",
            username: username,
            password: password
        }));
    }

    getLogin() {
        return Vue.axios.get(`${API_HOST}/api/login`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    logOut() {
        return Vue.axios.post(`${API_HOST}/api/logout`, {}, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    getRegisterHashCode({
                            organizationInn,
                            organizationName,
                            organizationAddress,
                            vatRegCode,
                            branchCode,
                            branchName,
                            isLtd,
                            pinfl,
                            contractSum,
                            userFullName,
                            organizationPhoneNumber,
                            username,
                            password,
                            contractSignerUnitId,
                            accountNumber,
                            mfo,
                            contractNumber,
                            contractDateFrom,
                            contractDateTo,
                            HasContractWithGlobalUnit
                        }) {
        return Vue.axios.post(`${API_HOST}/api/RegisterHashCode`, {
            OrganizationInn: organizationInn,
            OrganizationName: organizationName,
            OrganizationAddress: organizationAddress,
            OrganizationPhoneNumber: organizationPhoneNumber,
            UserFullName: userFullName,
            Username: username,
            Password: password,
            VatRegCode: vatRegCode,
            BranchCode: branchCode,
            BranchName: branchName,
            IsLtd: isLtd,
            Pinfl: pinfl,
            ContractSum: contractSum,
            ContractSignerUnitId: contractSignerUnitId,
            AccountNumber: accountNumber,
            Mfo: mfo,
            ContractNumber: contractNumber,
            ContractDateFrom: contractDateFrom ? contractDateFrom.format("DD.MM.YYYY") : null,
            ContractDateTo: contractDateTo ? contractDateTo.format("DD.MM.YYYY") : null,
            HasContractWithGlobalUnit: HasContractWithGlobalUnit
        })
    }

    register({guid, signature}) {
        return Vue.axios.post(`${API_HOST}/api/Register`, {
            Guid: guid,
            Signature: signature,
        })
    }

    checkAdmin(accessToken) {
        return Vue.axios.get(`${API_HOST}/api/AdminLogin`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }
}

export default new AuthService()
